import { gql } from '@apollo/client';

const CHECKLIST_TEMPLATE_FIELDS = `
  id
  source
  hobbyId
  scope
  applicableHobbies
  name
  editable
  items {
    id
    title
    category
  }
`;

export const GET_CHECKLIST_TEMPLATES = gql`
  query GetChecklistTemplates($hobbyId: String) {
    getChecklistTemplates(hobbyId: $hobbyId) {
      ${CHECKLIST_TEMPLATE_FIELDS}
    }
  }
`;

export const ADD_CHECKLIST_TEMPLATE = gql`
  mutation AddChecklistTemplate($input: ChecklistTemplateInput!) {
    addChecklistTemplate(input: $input) {
      ${CHECKLIST_TEMPLATE_FIELDS}
    }
  }
`;

export const DELETE_CHECKLIST_TEMPLATE = gql`
  mutation DeleteChecklistTemplate($id: ID!) {
    deleteChecklistTemplate(id: $id)
  }
`;
